import {
    CUSTOMER_PANEL_MIN_WIDTH,
    CUSTOMER_PANEL_MAX_WIDTH,
    LS_LAYOUT_COLLAPSE_KEY,
    LAYOUT_STATE_SMALL,
    LAYOUT_STATE_BIG,
    LAYOUT_STATE_COLLAPSED,
} from "constants/index";

const ACTIONS = {
    TOGGLE_CUSTOMER_COLLAPSE_STATE: "TOGGLE_CUSTOMER_COLLAPSE_STATE",
    SET_CUSTOMER_CONTENT_WIDTH: "SET_CUSTOMER_CONTENT_WIDTH",
    TOGGLE_TABS_TRIPLE_COLLAPSE_STATE: "TOGGLE_TABS_TRIPLE_COLLAPSE_STATE",
    TOGGLE_TABS_COLLAPSE_STATE: "TOGGLE_TABS_COLLAPSE_STATE",
    SET_TABS_SMALLER_COLLAPSE_STATE: "SET_TABS_SMALLER_COLLAPSE_STATE",
    SET_CUSTOMER_COLLAPSE_STATE: "SET_CUSTOMER_COLLAPSE_STATE",
};


// const LAYOUT_STATE_SMALL = "layout-collapse-small";
// const LAYOUT_STATE_BIG = "layout-collapse-big";
// const LAYOUT_STATE_COLLAPSED = "layout-collapse-collapsed";

const CUSTOMER_DEFAULT_STATE = LAYOUT_STATE_SMALL;
const TAB_DEFAULT_STATE = LAYOUT_STATE_BIG;

const CUSTOMER_STATE_CONFIG = [LAYOUT_STATE_SMALL, LAYOUT_STATE_BIG]; // just info scheme

const TABS_STATE_CONFIG = [LAYOUT_STATE_BIG, LAYOUT_STATE_SMALL, LAYOUT_STATE_COLLAPSED]; // just info scheme

const APPEAL_MIN_WIDTH = 500;

const TABS_BIG_MIN_WIDTH = 440;

const MENU_WIDTH = 50;

const MARGINS = 20;


const GET_MAX_WINDOW_WIDTH_TO_AUTO_COLLAPSE = customerPanelWidth => MENU_WIDTH + customerPanelWidth + APPEAL_MIN_WIDTH + TABS_BIG_MIN_WIDTH + MARGINS;

export function getIsAppealAutoCollapseNeeded(width) {
    const windowWidth = window.innerWidth; 
    const MAX_WIDTH = GET_MAX_WINDOW_WIDTH_TO_AUTO_COLLAPSE(width || CUSTOMER_PANEL_MAX_WIDTH);
    return windowWidth <= MAX_WIDTH;
}


let cachedLayoutCollapse = {};
try {
	cachedLayoutCollapse = JSON.parse(localStorage.getItem(LS_LAYOUT_COLLAPSE_KEY));
} catch(e) {
	console.error("reducers/layoutCollapse:: Error during receiving layoutCollapse from LocalStorage: ", e);
}

const DEFAULT_STATE = {
    appealClient: {
        width: CUSTOMER_PANEL_MIN_WIDTH, // get from local storage
        collapseState: CUSTOMER_DEFAULT_STATE,
    },
    customer: {
        width: CUSTOMER_PANEL_MIN_WIDTH, // get from local storage
        collapseState: CUSTOMER_DEFAULT_STATE,
    },
    contactPerson: {
        width: CUSTOMER_PANEL_MIN_WIDTH, // get from local storage
        collapseState: CUSTOMER_DEFAULT_STATE,
    },
    appeal: {
        collapseState: TAB_DEFAULT_STATE,
    },
    order: {
        collapseState: TAB_DEFAULT_STATE,
    },
    resource: {
        collapseState: TAB_DEFAULT_STATE,
    },
    service: {
        collapseState: TAB_DEFAULT_STATE,
    },
    specification: {
        collapseState: TAB_DEFAULT_STATE,
    },
    bunits: {
        collapseState: TAB_DEFAULT_STATE,
    }
};

// start with default state and overwrite it with cached from LS 
// in that way we could keep adding new keys and keep existing one from the LS
const initialState = {...DEFAULT_STATE, ...cachedLayoutCollapse};

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.TOGGLE_CUSTOMER_COLLAPSE_STATE: {
            // get width and state based on current state
            // const collapseState = "";
            const currentState = state[action.clientTabType] && state[action.clientTabType].collapseState;
            if (currentState) {
                const newState = currentState === LAYOUT_STATE_BIG ? LAYOUT_STATE_SMALL : LAYOUT_STATE_BIG;
                const newWidth = newState === LAYOUT_STATE_BIG ? CUSTOMER_PANEL_MAX_WIDTH : CUSTOMER_PANEL_MIN_WIDTH;

                // calculate appeal tabs auto collapse (in order to fit on small laptops)
                let appealAutoCollapse = {};
                const appealCollapseState = state.appeal && state.appeal.collapseState;
                if (newState === LAYOUT_STATE_BIG && appealCollapseState === LAYOUT_STATE_BIG) {
                    const isAppealAutoCollapse = getIsAppealAutoCollapseNeeded();
                    if (isAppealAutoCollapse) {
                        appealAutoCollapse = {
                            appeal: {
                                collapseState: LAYOUT_STATE_SMALL,
                            },
                        };
                    }
                }

                return { ...state, ...appealAutoCollapse, [action.clientTabType]: { ...state[action.clientTabType], collapseState: newState, width: newWidth } };
            } else {
                console.warn("layoutCollapse::TOGGLE_CUSTOMER_COLLAPSE_STATE: clientTabType is not found", action.clientTabType);
                return state;
            }
        }

        case ACTIONS.SET_CUSTOMER_COLLAPSE_STATE: {
            // get width and state based on current state
            // const collapseState = "";
            const currentState = state[action.clientTabType] && state[action.clientTabType].collapseState;
            if (currentState) {
                const newState = action.state;

                return { ...state, [action.clientTabType]: { ...state[action.clientTabType], collapseState: newState } };
            } else {
                console.warn("layoutCollapse::TOGGLE_CUSTOMER_COLLAPSE_STATE: clientTabType is not found", action.clientTabType);
                return state;
            }
        }


        case ACTIONS.SET_CUSTOMER_CONTENT_WIDTH: {
            let newState = state[action.clientTabType] && state[action.clientTabType].collapseState;
            if (newState) {
                if (action.width >= CUSTOMER_PANEL_MAX_WIDTH) {
                    newState = LAYOUT_STATE_BIG;
                }
                if (action.width <= CUSTOMER_PANEL_MIN_WIDTH) {
                    newState = LAYOUT_STATE_SMALL;
                }
                const currentWidth = state[action.clientTabType].width;
                const currentState = state[action.clientTabType].collapseState;
                // set to small if width was changed and state was big
                if (currentState === LAYOUT_STATE_BIG && action.width < currentWidth) {
                    newState = LAYOUT_STATE_SMALL;
                }

                let newWidth = action.width;
                if (action.width > CUSTOMER_PANEL_MAX_WIDTH) {
                    newWidth = CUSTOMER_PANEL_MAX_WIDTH;
                }
                if (action.width < CUSTOMER_PANEL_MIN_WIDTH) {
                    newWidth = CUSTOMER_PANEL_MIN_WIDTH;
                }

                // calculate appeal tabs auto collapse (in order to fit on small laptops)
                let appealAutoCollapse = {};
                const appealCollapseState = state.appeal && state.appeal.collapseState;
                if (newState === LAYOUT_STATE_BIG && appealCollapseState === LAYOUT_STATE_BIG) {
                    const isAppealAutoCollapse = getIsAppealAutoCollapseNeeded();
                    if (isAppealAutoCollapse) {
                        appealAutoCollapse = {
                            appeal: {
                                collapseState: LAYOUT_STATE_SMALL,
                            },
                        };
                    }
                }
                // console.log({width: action.width, newWidth, currentWidth});
                return { ...state, ...appealAutoCollapse, [action.clientTabType]: { ...state[action.clientTabType],  collapseState: newState, width: newWidth} };
            } else {
                console.warn("layoutCollapse::SET_CUSTOMER_CONTENT_WIDTH: clientTabType is not found", action.clientTabType);
                return state;
            }
        }


        // toggle between big, small, collapsed
        case ACTIONS.TOGGLE_TABS_TRIPLE_COLLAPSE_STATE: {
            const currentState = state[action.tabType] && state[action.tabType].collapseState;
            
            if (currentState) {
                let newState = LAYOUT_STATE_BIG;

                if (currentState === LAYOUT_STATE_BIG) {
                    newState = LAYOUT_STATE_SMALL;
                }

                if (currentState === LAYOUT_STATE_SMALL) {
                    newState = LAYOUT_STATE_COLLAPSED;
                }

                // calculate appeal customer auto collapse (in order to fit on small laptops)
                let appealClientAutoCollapse = {};
                const appealClientCollapseState = state.appealClient && state.appealClient.collapseState;
                if (newState === LAYOUT_STATE_BIG && appealClientCollapseState === LAYOUT_STATE_BIG) {
                    const isAppealAutoCollapse = getIsAppealAutoCollapseNeeded();
                    if (isAppealAutoCollapse) {
                        appealClientAutoCollapse = {
                            appealClient: {
                                collapseState: LAYOUT_STATE_SMALL,
                                width: CUSTOMER_PANEL_MIN_WIDTH
                            },
                        };
                    }
                }

                return { ...state, ...appealClientAutoCollapse, [action.tabType]: { ...state[action.tabType], collapseState: newState } };
            } else {
                console.warn("layoutCollapse::TOGGLE_TABS_TRIPLE_COLLAPSE_STATE: tabType is not found", action.tabType);
                return state;
            }
        }

        case ACTIONS.SET_TABS_SMALLER_COLLAPSE_STATE: {
            const currentState = state[action.tabType] && state[action.tabType].collapseState;
            
            if (currentState) {
                if (currentState === LAYOUT_STATE_BIG) {
                    const newState = action.state;
                    return { ...state, [action.tabType]: { ...state[action.tabType], collapseState: newState } };
                }
                return state;
            } else {
                console.warn("layoutCollapse::SET_TABS_SMALLER_COLLAPSE_STATE: tabType is not found", action.tabType);
                return state;
            }
        }

        // toggle between big (expanded) and collapsed state
        case ACTIONS.TOGGLE_TABS_COLLAPSE_STATE: {
            const currentState = state[action.tabType] && state[action.tabType].collapseState;
            
            if (currentState) {
                const newState = currentState === LAYOUT_STATE_BIG ? LAYOUT_STATE_COLLAPSED : LAYOUT_STATE_BIG;

                return { ...state, [action.tabType]: { ...state[action.tabType], collapseState: newState } };
            } else {
                console.warn("layoutCollapse::TOGGLE_TABS_COLLAPSE_STATE: tabType is not found", action.tabType);
                return state;
            }
        }

        default: {
            return state;
        }
    }
};

export const toggleCustomerCollapseState = (clientTabType) => ({
    type: ACTIONS.TOGGLE_CUSTOMER_COLLAPSE_STATE,
    clientTabType // appealClient / customer / contactPerson
});

export const setCustomerContentWidth = (clientTabType, width) => ({
    type: ACTIONS.SET_CUSTOMER_CONTENT_WIDTH,
    clientTabType,// appealClient / customer / contactPerson
    width,
});

export const setCustomerCollapseState = (clientTabType, state) => ({
    type: ACTIONS.SET_CUSTOMER_COLLAPSE_STATE,
    clientTabType,// appealClient / customer / contactPerson
    state,
});

export const toggleTabsTripleCollapseState = (tabType) => ({
    type: ACTIONS.TOGGLE_TABS_TRIPLE_COLLAPSE_STATE,
    tabType,
})

export const setTabsSmallerCollapseState = (tabType, state) => ({
    type: ACTIONS.SET_TABS_SMALLER_COLLAPSE_STATE,
    tabType,
    state,
})


export const toggleTabsCollapseState = (tabType) => ({
    type: ACTIONS.TOGGLE_TABS_COLLAPSE_STATE,
    tabType,
})
